"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleImageUrlBuilder = void 0;
const VehicleIdentifierValidator_1 = require("../validation/VehicleIdentifierValidator");
class VehicleImageUrlBuilder {
    constructor(customConfig) {
        this.customConfig = customConfig;
        this.fallbackViewDirection = 'side';
        this.fallbackAngle = 'right';
        this.volkswagenIdentifier = 'volkswagen';
        this.commercialVehiclesIdentifier = 'commercialVehicles';
        this.vehicleImageEndpoint = 'vehicleimages/exterior/';
    }
    getUrlForImageRequestWithDefaultView(vehicle) {
        let viewDirection;
        let angle;
        try {
            if (VehicleIdentifierValidator_1.VehicleIdentifierValidator.isCommercialVehicleVin(vehicle.vin)) {
                viewDirection = this.customConfig.defaultViews[this.commercialVehiclesIdentifier].viewDirection;
                angle = this.customConfig.defaultViews[this.commercialVehiclesIdentifier].angle;
            }
            else {
                viewDirection = this.customConfig.defaultViews[this.volkswagenIdentifier].viewDirection;
                angle = this.customConfig.defaultViews[this.volkswagenIdentifier].angle;
            }
        }
        catch (e) {
            viewDirection = this.fallbackViewDirection;
            angle = this.fallbackAngle;
        }
        return (this.vehicleImageEndpoint +
            this.getVehicleUrlParams(vehicle) +
            `?viewDirection=${viewDirection}&angle=${angle}`);
    }
    getVehicleUrlParams(vehicle) {
        return !vehicle.vin
            // Important: a space (%20) in front of the commissionNumber is needed in order to retrieve the images from the VILMA service.
            // %20: This ensures the space is represented in the encoded URL, and it will not be removed by the browser or HTTP client.
            ? `%20${vehicle.commissionNumber}/${vehicle.bid}/${vehicle.commissionNumberYear}`
            : vehicle.vin;
    }
}
exports.VehicleImageUrlBuilder = VehicleImageUrlBuilder;
//# sourceMappingURL=VehicleImageUrlBuilder.js.map